const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['dobbies'] = {
        c: () => require('partner/themes/dobbies/dobbies.tsx'),
        $type: 'themeModule',
        da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', moduleName: 'header',runOn: 0},{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', moduleName: 'loyalty-sign-up',runOn: 0},{name:'bundleProductsShareState',  path:'actions/bundle-products-oos-state', moduleName: 'buybox',runOn: 0},{name:'cartItemsChanges',  path:'themes/dobbies/actions/get-cart-items-updates', moduleName: 'header',runOn: 0},{name:'cartSharedState',  path:'actions/cart-state-share', moduleName: 'buybox',runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', moduleName: 'content-block',runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', moduleName: 'buybox',runOn: 0},{name:'checkoutModulesSharedState',  path:'actions/checkout-modules-state-share', moduleName: 'checkout-delivery-options',runOn: 0},{name:'checkoutModulesSharedState',  path:'actions/checkout-modules-state-share', moduleName: 'checkout',runOn: 0},{name:'clickCollectModalState',  path:'actions/pdp-click-collect-modal-state.action', moduleName: 'buybox',runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'account-loyalty',runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'header',runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', moduleName: 'loyalty-sign-up',runOn: 0},{name:'getCustomerAddress',  path:'themes/dobbies/actions/get-customer-address.action', moduleName: 'loyalty-sign-up',runOn: 0},{name:'getUnbxdRecommendationsCount',  path:'actions/get-unbxd-recommendations-count.action', moduleName: 'buybox',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'account-welcome-tile',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'account-profile',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'buybox',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'header',runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', moduleName: 'navigation-menu',runOn: 0},{name:'modulesSharedState',  path:'themes/dobbies/actions/modules-state-share-action', moduleName: 'account-loyalty-tile',runOn: 0},{name:'modulesSharedState',  path:'themes/dobbies/actions/modules-state-share-action', moduleName: 'content-block',runOn: 0},{name:'plantPotsProductCountState',  path:'actions/get-plant-pots-product-count', moduleName: 'buybox',runOn: 0},{name:'productAttributes',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', moduleName: 'media-gallery',runOn: 0},{name:'unbxdAddedToCartProduct',  path:'actions/get-unbxd-add-to-cart-product.action', moduleName: 'buybox',runOn: 1}],
        definitionExtensions: ['account-address-tile','account-loyalty-tile','account-loyalty','account-profile','account-welcome-tile','account-wishlist-tile','breadcrumb','buybox','cart','checkout-delivery-options','checkout','content-block','footer-category','header','loyalty-sign-up','media-gallery','navigation-menu','order-confirmation','order-details','order-history','ratings-histogram','search-result-container','sign-in'],
        iNM: false,
        ns: '__local__',
        n: 'dobbies',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'dobbies.theme.settings.json',
        md: 'src/themes/dobbies'
    });
        

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/bundle-products-oos-state';
            let dataAction = require('partner/actions/bundle-products-oos-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/cart-state-share';
            let dataAction = require('partner/actions/cart-state-share');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/checkout-modules-state-share';
            let dataAction = require('partner/actions/checkout-modules-state-share');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/checkout-modules-state-share';
            let dataAction = require('partner/actions/checkout-modules-state-share');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-plant-pots-product-count';
            let dataAction = require('partner/actions/get-plant-pots-product-count');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-unbxd-add-to-cart-product.action';
            let dataAction = require('partner/actions/get-unbxd-add-to-cart-product.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/get-unbxd-recommendations-count.action';
            let dataAction = require('partner/actions/get-unbxd-recommendations-count.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'actions/pdp-click-collect-modal-state.action';
            let dataAction = require('partner/actions/pdp-click-collect-modal-state.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbies/actions/get-cart-items-updates';
            let dataAction = require('partner/themes/dobbies/actions/get-cart-items-updates');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbies/actions/get-customer-address.action';
            let dataAction = require('partner/themes/dobbies/actions/get-customer-address.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbies/actions/modules-state-share-action';
            let dataAction = require('partner/themes/dobbies/actions/modules-state-share-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'themes/dobbies/actions/modules-state-share-action';
            let dataAction = require('partner/themes/dobbies/actions/modules-state-share-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };